import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IErrorItem {
    FriendlyMessage?: string;
    Message?: string;
    ErrorId?: string;
}
export interface IErrorData {
    ExceptionType: string;
    Errors: IErrorItem[];
}

export interface IErrorDialogData {
    isVisible: boolean;
    errorData: IErrorData;
}

@Injectable()
export class ErrordialogService {
  private errorSource = new Subject<IErrorData>();
  public errorSourceObservable = this.errorSource.asObservable();
  private errorDialogData: IErrorDialogData;

  constructor() { }

  public setErrorData(data: IErrorData) {
      this.errorSource.next(data);
  }

  public setErrorMessage(message:string) {
    const errorData:IErrorData = {
        ExceptionType :'Exception',
        Errors : [ {FriendlyMessage:message} ]  
    }
    this.errorSource.next(errorData);
  }
}
